module.exports = __webpack_public_path__ + "img/stone-path-inner-corner.d0ee4a9f.png";